import React from "react";
import { Outlet } from "react-router-dom";

const CypressJavaScriptOutputPage = () => {
  return (
    <div style={{ maxHeight: "100%", width: "100%" }}>
      <Outlet />
    </div>
  );
};

export default CypressJavaScriptOutputPage; 